<template>
  <div class="container">
    <div class="order box">
      <div class="title">
        <span>放行信息</span>
        <div class="right">
          <el-button v-show="showBtn" @click="dialogVisible = true">拒绝</el-button>
          <el-button type="primary" v-show="showBtn" @click="event().passCommit()">通过</el-button>
        </div>
      </div>
      <div class="info-box">
        <div class="row">
          <span>状态：</span>
          <span>{{info.status | status}}</span>
        </div>
        <div class="row">
          <span>企业：</span>
          <span>{{info.enterpriseName}}</span>
        </div>
        <div class="row">
          <span>电话号码：</span>
          <span>{{info.mobile}}</span>
        </div>
        <div class="row">
          <span>订单编号：</span>
          <span>{{info.orderNum}}</span>
        </div>
        <div class="row">
          <span>联系人：</span>
          <span>{{info.name}}</span>
        </div>
        <div class="row">
          <span>截止日期：</span>
          <span>{{info.offDate}}</span>
        </div>
        <div class="row">
          <span>类型：</span>
          <span>{{info.type | type}}</span>
        </div>
        <div class="row">
          <span>所属产业：</span>
          <span>{{info.industryName}}</span>
        </div>
      </div>
    </div>
    <div class="visit box">
      <div class="title">
        <span>物品信息</span>
      </div>
      <div class="info-box">
        <div class="row">
          <span>物品清单：</span>
          <el-input
            type="textarea"
            class="text"
            v-model="text"
            :autosize="{ minRows: 10, maxRows: 20 }">
            </el-input>
        </div>
      </div>
      <div class="info-box">
        <UpLoadImg
            :disabled="true"
            :img="info.pictureList"
            :size="[350, 180]"
            @get-files="getFiles"/>
      </div>
    </div>
    <div class="refuse box" v-if="info.status === 2">
      <div class="title">
        <span>拒绝原因</span>
      </div>
      <div class="info-box">
        <div class="row">
          <span>拒绝原因：</span>
          <el-input
            type="textarea"
            class="text"
            v-model="info.refusalReason"
            :autosize="{ minRows: 10, maxRows: 20 }">
          </el-input>
        </div>
      </div>
    </div>
    <div class="return">
      <el-button @click="returnBack" type="primary">返回</el-button>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="500px">
      <div class="alert-content">
        <el-input
          type="textarea"
          show-word-limit
          placeholder="请填写拒绝原因"
          v-model="body.refusalReason"
          maxlength="100"
          :autosize="{ minRows: 10, maxRows: 20 }"/>
      </div>
      <div class="btn">
        <el-button type="primary" @click="event().putCommit()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getVisitInfo, putApply } from '@/api/user'
import env from '@/configs/env'
import UpLoadImg from '@/components/upload-img'
export default {
  data() {
    return {
      info: '',
      showBtn: false,
      dialogVisible: false,
      body: {
        uuid: '',
        status: '',
        refusalReason: ''
      },
      text: '',
      imgUrl: ''
    }
  },
  filters: {
    status: function(val) {
      if (val === 0) {
        return '待审核'
      } else if (val === 1) {
        return '已通过'
      } else return '已拒绝'
    },
    type: function(val) {
      if (val === 0) {
        return '普通放行'
      } else return '退租放行'
    }
  },
  mounted() {
    this.imgUrl = env.qnImgDomain
    this.network().getVisitInfo()
    this.body.uuid = this.$route.query.uuid
  },
  methods: {
    event() {
      return {
        putCommit: () => {
          if (!this.body.refusalReason) {
            window.vm.$message.error('请填写信息')
            return
          }
          this.body.status = 2
          this.network().putApply()
          this.body.refusalReason = ''
          this.dialogVisible = false
        },
        passCommit: () => {
          this.body.status = 1
          this.network().putApply()
        }
      }
    },
    network() {
      return {
        getVisitInfo: async() => {
          const { data } = await getVisitInfo(this.$route.query.uuid)
          this.info = data
          this.text = data.content
          if (data.status === 0) this.showBtn = true
        },
        putApply: async() => {
          await putApply(this.body)
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.$router.push({
            path: `/user-management/user-details/pass/get/${this.body.uuid}`,
            query: { uuid: this.body.uuid }
          })
        }
      }
    },
    getFiles(file, files) {
      // console.log(file,files);
      const arr = []
      files.forEach((item) => {
        if (item.response === undefined) {
          arr.push(item.url.substring(item.url.lastIndexOf('/') + 1))
        } else {
          arr.push(item.response)
        }
      })
      this.info.pictureList = arr
    },
    returnBack(){
      this.$router.go(-1)
    }
  },
  beforeRouteLeave(to, form, next){
    if (!to.path.includes('/user-management/user-details/get')) {
      this.$store.dispatch('global/deleteRoute', 'DetailsManagement')
    }
    next()
  },
  components: {
    UpLoadImg
  }
}
</script>

<style scoped lang="scss">
.container{
  height: 100%;
  background-color: #dfdede;
  .order{
    .right{
      float: right;
      button{
        width: 120px;
      }
    }
  }
  .box{
    margin-bottom: 15px;
    background: #ffffff;
    padding: 15px 30px;
    border-radius: 5px;
    .title{
      font-weight: bold;
      margin-bottom: 60px;
    }
    .row{
      margin-bottom: 30px;
      span{
        font-size: 14px;
        &:nth-child(1){
          flex: 1;
          color: grey;
        }
        &:nth-child(2){
          flex: 5;
        }
      }
    }
    .info-box{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .row{
        display: flex;
        width: 33%;
        margin-bottom: 60px;
        .text{
          flex: 5;
        }
      }
      .row-img{
        display: flex;
        margin: 0 25px 100px 0;
      }
      img{
        width: 150px;
      }
    }
  }

  .btn{
    margin-top: 15px;
    display: flex;
    justify-content: center;
    button{
      width: 70%;
    }
  }

  .return{
    text-align: center;
    margin-bottom: 30px;
  }
}
</style>
